export default {
  // ========== Tooltips de estado ==========
  outOfSpecTooltip: 'Esta sesión está fuera de las horas pedagógicas configuradas para la asignatura.',
  completedTooltip: 'Completado',

  // ========== Etiquetas / textos de tabla ==========
  supportResources: 'Recursos de Apoyo',

  // ========== Limpiar fila ==========
  clearRow: 'Limpiar fila',
  clearRowConfirmTitle: '¿Limpiar la sesión {order}?',
  clearRowConfirmText:
    'Se quitarán todas las selecciones de la fila, incluida la evaluación asociada. Esta acción no se puede deshacer.',

  // ========== Modales ==========
  sessionObservationsModalTitle: 'Observaciones de sesión {order}',
  selectEntity: 'Seleccionar {entity}',
  contentsDefinedByEntity: 'Los {criteria} se definen por {raMicro}',
  removeSelection: '-- Eliminar Selección --',
  contentsInEntity: 'Contenidos en {entity}:',
  contentsOfEntity: 'Contenidos de los {entity}:',
  basicBibliography: 'Bibliografía Básica',
  feedback: 'Retroalimentación',
  directTeachingActivities: 'Actividades de Docencia Directa',
  minimumStrategiesShown: 'Se muestran',
  coloredWord: 'coloreadas',
  minimumStrategiesDescription: 'las {strategies} definidas como mínimas para la {matter}.',
  minimumStrategiesOfEntity: 'Estratégias Mínimas de la {entity}',

  // ========== Validaciones de sesión ==========
  selectOneError: 'Seleccione un {entity}.',
  selectAtLeastOneContent: 'Seleccione al menos un Contenido.',
  selectSomeError: 'Seleccione alguna {entity}.',
  selectDirectTeachingActivityError: 'Seleccione alguna actividad de docencia directa.',
};
